import * as React from "react";
const SvgWr = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 45 45", ...props }, /* @__PURE__ */ React.createElement("g", { style: {
  opacity: 1,
  fill: "#fff",
  fillOpacity: 1,
  fillRule: "evenodd",
  stroke: "#000",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeOpacity: 1
} }, /* @__PURE__ */ React.createElement("path", { d: "M9 39 36 39 36 36 9 36 9 39zM12 36 12 32 33 32 33 36 12 36zM11 14 11 9 15 9 15 11 20 11 20 9 25 9 25 11 30 11 30 9 34 9 34 14", style: {
  strokeLinecap: "butt"
} }), /* @__PURE__ */ React.createElement("path", { d: "M 34,14 L 31,17 L 14,17 L 11,14" }), /* @__PURE__ */ React.createElement("path", { d: "M 31,17 L 31,29.5 L 14,29.5 L 14,17", style: {
  strokeLinecap: "butt",
  strokeLinejoin: "miter"
} }), /* @__PURE__ */ React.createElement("path", { d: "M 31,29.5 L 32.5,32 L 12.5,32 L 14,29.5" }), /* @__PURE__ */ React.createElement("path", { d: "M 11,14 L 34,14", style: {
  fill: "none",
  stroke: "#000",
  strokeLinejoin: "miter"
} })));
export default SvgWr;
